// extracted by mini-css-extract-plugin
export default {"bg-logo":"Button_bg-logo__NQQ3u","bg-white":"Button_bg-white__OfbsH","lg-bg-logo":"Button_lg-bg-logo__jvts7"};